import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { translate } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';

import { login, updatePassword } from 'actions';
import { redirect } from 'widgets/I18nLink';
import { createValidator } from 'utils/validate';

import {
  defaultValidateHandler,
  defaultValidateStatus,
  defaultOnChange,
  defaultOnBlur
} from 'utils/form';

import './auth-page.css';

class UpdatePasswordForm extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      password: '',
      passwordConfirm: '',
      errors: {}
    };

    this.validateHandler = defaultValidateHandler.bind(this);
    this.validationState = defaultValidateStatus.bind(this);

    this.handleFieldChange = defaultOnChange.bind(this);
    this.handleFieldBlur = defaultOnBlur.bind(this);
  }

  componentWillMount() {
    const { t } = this.props;

    const rules = {
      password: {
        minlength: {
          data: 6,
          message: t('Must be at least 6 characters')
        }
      },
      passwordConfirm: {
        equals: t('Passwords must match')
      }
    };

    this.validate = createValidator(rules, { equals: this.validatePasswords });
  }

  validatePasswords = (value, rule) =>
    this.state.password === this.state.passwordConfirm;

  handleSubmit = (event) => {
    event.preventDefault();

    const isFormValid = this.validateHandler();
    if (!isFormValid) {
      return;
    }

    const { password } = this.state;
    this.props.updatePassword({ code: this.props.code, password })
    .then(action => {
      if (action.response && action.response.email) {
        this.props.login({ username: action.response.email, password });
      } else {
        redirect('/');
      }
    });
  };

  getProperties = () => {
    const { password, passwordConfirm } = this.state;
    return { password, passwordConfirm };
  };

  render() {
    const { t } = this.props;

    return (
      <form className="auth-form" onSubmit={this.handleSubmit}>
        <FormGroup controlId="password" validationState={this.validationState('password')}>
          <ControlLabel>{t('Password')}:</ControlLabel>
          <FormControl
            name="password"
            type="password"
            value={this.state.password}
            onChange={this.handleFieldChange}
            onBlur={this.handleFieldBlur}
          />
          {this.state.errors.password &&
            <HelpBlock>{this.state.errors.password}</HelpBlock>
          }
        </FormGroup>

        <FormGroup controlId="passwordConfirm" validationState={this.validationState('passwordConfirm')}>
          <ControlLabel>{t('Confirm password')}:</ControlLabel>
          <FormControl
            name="passwordConfirm"
            type="password"
            value={this.state.passwordConfirm}
            onChange={this.handleFieldChange}
            onBlur={this.handleFieldBlur}
          />
          {this.state.errors.passwordConfirm &&
            <HelpBlock>{this.state.errors.passwordConfirm}</HelpBlock>
          }
        </FormGroup>

        <Button
          bsStyle="success"
          type="submit"
          className="order-button"
        >
          {t('Update password')}
        </Button>
      </form>
    );
  }
}

class RestorePasswordPage extends Component {
  render() {
    const { t } = this.props;

    return (
      <div className="auth-page">
        <Grid>
          <Row>
            <Col lg={12} className="title-block">
              <h1 className="title">{t('Create your account on BikesBooking.com')}</h1>
            </Col>
            <Col lg={8} md={7} sm={6} xs={12}>
              <div className="custom-list">
                <ul>
                  <li>
                    <b>{t('Login or register a free customer account, make and manage your bookings online')}</b>
                    <p>{t('If you own a rental company, please use "Add rental company" button above to create a business account')}</p>
                  </li>
                  <li>
                    <b>{t('Book scooters, bicycles, ATV\'s and motorcycles from 900+ providers in 42 countries')}</b>
                  </li>
                  <li>
                    <b>{t('We guarantee the Best prices and also Free cancellations in most of the cases')}</b>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={4} md={5} sm={6} xs={12}>
              <UpdatePasswordForm
                t={t}
                code={this.props.params.code}
                login={this.props.login}
                updatePassword={this.props.updatePassword}
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    countries: state.app.countries.items
  };
}

export default asyncConnect(
  [],
  mapStateToProps,
  { login, updatePassword }
)(translate(['translation'])(RestorePasswordPage));



// WEBPACK FOOTER //
// ./src/components/AuthPage/RestorePasswordPage.js